import React from 'react'
import { ManageState } from './manageState';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import TableCustom from '../../../../components/table/tableCustom';
import StateComponents from '../../../../components/state-component/StateComponents';
import { useNavigate } from 'react-router-dom';
import { debouncedApiCall } from '../../../../utils/app.utils';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageSurveys = (props: Props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        setKeyword
    } = ManageState();
    return (
        <ContainerLayout
            title={t("จัดการแบบสำรวจ")}
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: t("จัดการข้อมูลคอร์สออนไลน์"),
                            name: t("จัดการข้อมูลคอร์สออนไลน์"),
                            disabled_match: true,
                            pathName: ""
                        },
                        {
                            key: t("จัดการแบบสำรวจ"),
                            name: t("จัดการแบบสำรวจ"),
                            pathName: routeName.cms.course_online_surveys
                        },
                    ]}
                />
            }
            content={

                <div className='w-full'>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 4
                                },
                                fieldProps: {
                                    startAdornment: <SearchIcon  />,
                                    placeholder: t("ค้นหา ชื่อ"),
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setKeyword }),
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE_RANGE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    onchange: handleChangeDateRange,
                                    value: date_range || [],
                                    onClear: handleClearDateRange,
                                    allowClear: true,
                                    placeholder: t("ช่วงวันที่")
                                }
                            },
                            {
                                type: "COMPONENT",
                                seq: 3,
                                fieldProps: {
                                    element: <></>
                                },
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                }
                            },
                            {
                                seq: 4,
                                type: "BUTTON",
                                gridProps: {
                                    xs: 6,
                                    md: 2
                                },
                                fieldProps: {
                                    justifyContent: "flex-end",
                                    buttonData: [
                                        {
                                            seq: 1,
                                            key: "ADD2",
                                            label: t("เพิ่มแบบสำรวจ"),
                                            buttonProps: {
                                                onClick: () => navigate(routeName.cms.course_online_surveys_create)
                                            },
                                            type: "ADD2"
                                        }
                                    ]
                                }
                            }
                        ]}
                    />
                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </div>
            }
        />
    )
}

export default ManageSurveys